// removed by extract-text-webpack-plugin
module.exports = {"PostItem":"src-components-Posts-PostItem----PostItem-module---PostItem---1_D9A","Feature":"src-components-Posts-PostItem----PostItem-module---Feature---313OV","Content":"src-components-Posts-PostItem----PostItem-module---Content---2iM57","Title":"src-components-Posts-PostItem----PostItem-module---Title---OE_Fj","Date":"src-components-Posts-PostItem----PostItem-module---Date---1Dorj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Posts/PostItem/PostItem.module.css
// module id = 135
// module chunks = 35783957827783 212839066777427